/** Idle: encouragement TTS then final deadline before auto-submit (aligned with other activities). */
export const IDLE_ENCOURAGEMENT_TIMEOUT = 20000; // 20s
export const IDLE_SUBMIT_TIMEOUT = 60000; // 1 min

export {
  HIGHLIGHT_DURATION,
  MAX_REPLAYS,
  TIME_BETWEEN_OPTIONS,
  TIME_BETWEEN_SILENT_OPTIONS,
} from '../../constants/assessmentScreenTimings';

/**
 * Sentinel in writtenInstructions marking a fill-in-the-blank gap. The prompt bar splits the
 * text on this token and renders a styled underline span in its place (see MmcPromptBar).
 * Authored in the item bank as literal text, e.g. "El gato es muy [BLANK] y duerme todo el día."
 */
export const BLANK_TOKEN = '[BLANK]';

/**
 * Option counts that lay out as a square grid rather than a single row. Only 4 occurs in
 * the Formative bank; 2, 3 and 5 read better in a row, and 5 is one item whose options
 * are full sentences.
 */
export const GRID_OPTION_COUNTS = new Set([4]);

/**
 * AosItemMode value marking a response that represents several selections rather than
 * one. MMC reads it as multi-select. item.mode describes the response shape, not the
 * item type -- type stays "mmc". Deliberately not 'grid': that is visualAttention's
 * positional 0/1 mask, and AOS decodes a grid response as JSON, which the delimited
 * key list below is not.
 */
export const MULTI_SELECT_MODE = 'multiSelect';

/**
 * Joins the selected option keys into the response, and joins the correct keys into
 * item.phrase on the authoring side, so AOS can split both to build the errors array.
 * Option text contains commas and spaces of its own (e.g. "lake, ice, steam"), so the
 * separator has to be something no option would carry.
 *
 * Every multi-select mmc item, which is what mode 'multiSelect' declares. Bucketing and
 * Sequence send their keys as an array instead.
 * AOS compares the selected keys as a set, so the order the child tapped is not significant.
 */
export const MULTI_SELECT_DELIMITER = ' ## ';


/** Prompt bar text shrink-to-fit: never scale below this, target this many rows before shrinking. */
export const MIN_PROMPT_FONT_SIZE_PX = 18;
export const PROMPT_TARGET_MAX_ROWS = 3;

export const LOG =
  process.env.NODE_ENV !== 'production'
    ? (...args) => console.log('[MMC]', ...args)
    : () => {};

/** UI element names this activity handles for show/hide/highlight/click triggers */
export const UI_ELEMENTS = new Set(['repeat', 'prompt', 'options', 'video', 'image', 'submit']);
